__turbopack_context__.v({
  "download-card": "u_4e6q_download-card",
  "download-card__category-divider": "u_4e6q_download-card__category-divider",
  "download-card__category-list": "u_4e6q_download-card__category-list",
  "download-card__category-list-item": "u_4e6q_download-card__category-list-item",
  "download-card__category-list-size-large": "u_4e6q_download-card__category-list-size-large",
  "download-card__category-list-size-medium": "u_4e6q_download-card__category-list-size-medium",
  "download-card__category-title": "u_4e6q_download-card__category-title",
  "download-card__title": "u_4e6q_download-card__title",
  "single": "u_4e6q_single",
});
